import React from "react";
import { ThemeContext } from "../../ContextProvider/ThemeContext";
import WindowSize from "../../Utils/WindowSize";
import styles from "./About.module.css";

const About = () => {
  const { newTheme } = React.useContext(ThemeContext);
  const [width] = WindowSize();
  const img =
    width < 650
      ? "./../../assets/26.png"
      : "https://github.com/RahulGoyal03/Portfolio/blob/main/public/developer.gif?raw=true";
  
  return (
    <div
      className={styles.container}
      style={{ boxShadow: `3px 3px 5px ${newTheme.line}` }}
    >
      <div className={styles.first}>
        <img
          src={
            "https://github.com/RahulGoyal03/Portfolio/blob/main/public/developer.gif?raw=true"
          }
          alt="Developer"
        />
      </div>
      <div className={styles.second}>
        <h1 style={{ color: `${newTheme.title}` }} className={styles.heading}>
          About Me
        </h1>
        <div className={styles.borderBottom} />
        <p style={{ color: `${newTheme.para}` }} className={styles.aboutMe}>
          Hello! I'm Kushagra Kamal, a passionate Full Stack Web Developer with a focus on the MERN stack. My journey into web development started with the curiosity of editing web pages, which led me to dive deeper into HTML, CSS, and JavaScript. 
          <br /> <br />
          Over the years, I have built a range of web applications, including large-scale projects that improved my understanding of development, teamwork, and problem-solving. I thrive in collaborative environments and am always eager to learn new technologies.
          <br /> <br />
          Currently, I'm looking for opportunities where I can apply my skills in building high-performance, scalable web applications and contribute to impactful projects. 
          <br /><br />
          I am excited to work with a team that shares my passion for continuous learning and innovation.
          <span style={{ color: `#00a0a0` }}>
            {" "} Looking forward to my next challenge as a full-stack developer!
          </span>
        </p>
      </div>
    </div>
  );
};

export default About;
